<template>
  <MasterLayout page_title="مرکز کنترل">
    <div class="mb-1 card">
      <div class="card-body">
        <div class="top-items">
          <div class="filter-items">
            <div><i class="far fa-arrows-split-up-and-left"></i>&nbsp;نوع :</div>
            <div :class="'item '+(filter === 'all'?'active':'')" class="item" @click="filter = 'all'">همه</div>
            <div :class="'item market_request '+(filter === 'market_request'?'active':'')" @click="filter = 'market_request'">درخواست کالا</div>
            <div :class="'item auction_request '+(filter === 'auction_request'?'active':'')" @click="filter = 'auction_request'">مزایده</div>
            <div :class="'item user_register '+(filter === 'user_register'?'active':'')" @click="filter = 'user_register'">ثبت نام</div>
            <div :class="'item ticket '+(filter === 'ticket'?'active':'')" @click="filter = 'ticket'">تیکت</div>
            <div :class="'item product_register '+(filter === 'product_register'?'active':'')" @click="filter = 'product_register'">محصول</div>
            <div :class="'item special_request '+(filter === 'special_request'?'active':'')" @click="filter = 'special_request'">درخواست کاربر ویژه</div>
          </div>
          <div class="sort_items">
            <div @click="sort = 'old'" :class="'item '+(sort === 'old'?'active':'')">قدیمی ترین</div>
            <div @click="sort = 'new'"  :class="'item '+(sort === 'new'?'active':'')">جدیدترین</div>
          </div>
        </div>
      </div>
    </div>
    <card>
      <div class="items-wrapper my-3">
        <div class="row">
          <div v-for="(item,index) in sortedItems" class="col-12 col-md-4 col-lg-3 mb-2">
            <div @click="openModal(index)" :class="'item '+item.type+(item.item.locked?' locked ':'')">
              <i v-if="item.item.locked" class="fas fa-lock lock-icon animate__animated animate__heartBeat animate__infinite"></i>
              <div class="op-item" v-if="item.type==='user_register'">
                <span class="icon"><i class="far fa-user-circle"></i></span>
                <span class="title">ثبت نام</span>
                <i class="fal fa-pipe"></i>
                <span> {{ item.item.title }} </span>
              </div>
              <div class="op-item" v-if="item.type==='market_request'">
                <span class="icon"><i class="far fa-shop"></i></span>
                <span class="title">درخواست کالا</span>
                <i class="fal fa-pipe"></i>
                <span> {{ item.item.product_title}} </span>
              </div>
              <div class="op-item" v-if="item.type==='auction_request'">
                <span class="icon"><i class="far fa-gavel"></i></span>
                <span class="title">مزایده</span>
                <i class="fal fa-pipe"></i>
                <span> {{ item.item.product_title}} </span>
              </div>
              <div class="op-item" v-if="item.type==='product_register'">
                <span class="icon"><i class="fas fa-box"></i></span>
                <span class="title">ثبت محصول</span>
                <i class="fal fa-pipe"></i>
                <span> {{ item.item.title}} </span>
              </div>
              <div class="op-item" v-if="item.type==='ticket'">
                <span class="icon"><i class="fas fa-user-headset"></i></span>
                <span class="title">تیکت</span>
                <i class="fal fa-pipe"></i>
                <span> {{ item.item.user_id.title}} </span>
              </div>
              <div class="op-item" v-if="item.type==='special_request'">
                <span class="icon"><i class="fas fa-sparkles"></i></span>
                <span class="title">کاربر ویژه</span>
                <i class="fal fa-pipe"></i>
                <span> {{ item.item.user_id.title}} </span>
              </div>
            </div>
          </div>
          <div v-if="!sortedItems.length" class="alert alert-danger col-10 col-md-5 mx-auto text-center"><i class="far fa-info-circle"></i>&nbsp;موردی برای نمایش وجود ندارد</div>
        </div>
      </div>
    </card>
      <div class="modal fade" id="operation-modal">
        <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                <span v-if="current_type === 'user_register'">ثبت نام کاربر</span>
                <span v-if="current_type === 'market_request'">درخواست بازار</span>
                <span v-if="current_type === 'auction_request'">درخواست مزایده</span>
                <span v-if="current_type === 'product_register'">درخواست ثبت محصول</span>
                <span v-if="current_type === 'ticket'">تیکت</span>
                <span v-if="current_type === 'special_request'">درخواست کاربر ویژه</span>
              </h5>
              <button class="close" @click="unlockItem"><i class="far fa-times"></i></button>
            </div>
            <div class="modal-body p-0">
              <Loading v-if="itemLoading"/>
              <div v-else-if="itemError">
                <div class="alert alert-danger">{{itemError}}</div>
              </div>
              <div v-else>
                <UserEdit v-if="currentItem._id && current_type === 'user_register'" :user_id="currentItem._id"></UserEdit>
                <MarketRequestEdit v-else-if="currentItem._id && current_type === 'market_request'" :request_id="currentItem._id"></MarketRequestEdit>
                <AuctionRequestEdit v-else-if="currentItem._id && current_type === 'auction_request'" :request_id="currentItem._id"></AuctionRequestEdit>
                <RequestRegisterProductEdit v-else-if="currentItem._id && current_type === 'product_register'" :request_id="currentItem._id"></RequestRegisterProductEdit>
                <TicketView v-else-if="currentItem._id && current_type === 'ticket'" :request_id="currentItem._id"></TicketView>
                <RequestSpecialAccountEdit v-else-if="currentItem._id && current_type === 'special_request'" :request_id="currentItem._id"></RequestSpecialAccountEdit>
              </div>
            </div>
          </div>
        </div>
      </div>
  </MasterLayout>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import {mapActions, mapGetters} from "vuex";
import * as Bootstrap from 'bootstrap-v4-rtl';
import {TempApi} from "@/api/TempApi";
import Loading from "@/components/Loading";
import {showSystemNoti} from "@/shared/helper";
import {OperatorsApi} from "@/api/OperatorsApi";
import UserEdit from "@/views/user/UserEdit";
import {AppApi} from "@/api/AppApi";
import Card from "@/components/forms/Card";
import MarketRequestEdit from "@/views/MarketRequest/MarketRequestEdit";
import AuctionRequestEdit from "@/views/auctionRequest/AuctionRequestEdit";
import RequestRegisterProductEdit from "@/views/RequestRegisterProduct/RequestRegisterProductEdit";
import TicketView from "@/views/Ticket/TicketView";
import RequestSpecialAccountEdit from "@/views/RequestSpecialAccount/RequestSpecialAccountEdit";

export default {
  name: "OperationsCenter",
  data()
  {
    return {
      socket: null,
      itemError:null,
      itemLoading:false,
      currentItem:{},
      items: [],
      current_type : null,
      modal:null,
      sort : 'old',
      filter : 'all',
    }
  },
  async mounted()
  {
    this.setPageTitle('مرکز کنترل');
    this.setPageLoading(false);
    this.setShowHead(false);
    this.modal = new Bootstrap.Modal(document.getElementById('operation-modal'),{
      keyboard:false,backdrop: 'static'
    });

    this.getItems();
    try
    {
      this.socket = await this.waitForSocket();
    } catch (e)
    {
    }
    if (this.socket)
      this.connectToSocket();
  },
  methods: {
      ...mapActions('app', {
        setPageTitle: 'setPageTitle',
        setPageLoading: 'setPageLoading',
        setShowHead: 'setShowHead'
      }),
    compare( a, b ) {
      if (new Date(a.item.createdAt) < new Date(b.item.createdAt) ){
        {
          if (this.sort === 'old')
            return -1;
          else
            return 1;
        }
      }
      if (new Date(a.item.createdAt) > new Date(b.item.createdAt)){
        if (this.sort === 'old')
          return 1;
        else
          return -1;
      }
      return 0;
    },
    filterItemsByType()
    {
      const items = [];
      const filter = this.filter;
      if (filter === 'all')
        return this.items;
      else if (filter === 'market_request')
      {
        for (let i = 0; i < this.items.length; i++)
        {
          if (this.items[i].type === 'market_request')
            items.push(this.items[i]);
        }
      }
      else if (filter === 'auction_request')
      {
        for (let i = 0; i < this.items.length; i++)
        {
          if (this.items[i].type === 'auction_request')
            items.push(this.items[i]);
        }
      }
      else if (filter === 'user_register')
      {
        for (let i = 0; i < this.items.length; i++)
        {
          if (this.items[i].type === 'user_register')
            items.push(this.items[i]);
        }
      }
      else if (filter === 'product_register')
      {
        for (let i = 0; i < this.items.length; i++)
        {
          if (this.items[i].type === 'product_register')
            items.push(this.items[i]);
        }
      }
      else if (filter === 'ticket')
      {
        for (let i = 0; i < this.items.length; i++)
        {
          if (this.items[i].type === 'ticket')
            items.push(this.items[i]);
        }
      }
      else if (filter === 'special_request')
      {
        for (let i = 0; i < this.items.length; i++)
        {
          if (this.items[i].type === 'special_request')
            items.push(this.items[i]);
        }
      }
      return items;
    },
    // async itemVerified()
    // {
    //   TempApi.itemVerified(this.currentItem._id);
    //   this.modal.hide()
    // },
    async getItems()
    {
      const r = await OperatorsApi.getOperatorsItems();
      if (r && r.items)
        this.items = r.items;
    },
    async openModal(i)
    {
      // if (this.items[i].item.locked)
      //   return;
      const item = this.sortedItems[i];
      const type = item.type;

      const currentItem = item.item;
      this.modal.handleUpdate(()=>{
        console.log('alive!!!')
      })

      this.itemLoading = true;
      this.itemError = null;
      this.modal.show()
      let r = null;
      if (type === 'user_register')
        r = await OperatorsApi.getUserSingleForEdit(currentItem._id);
      if (type === 'market_request')
        r = await OperatorsApi.getMarketRequestSingleForEdit(currentItem._id);
      if (type === 'auction_request')
        r = await OperatorsApi.getAuctionRequestSingleForEdit(currentItem._id);
      if (type === 'product_register')
        r = await OperatorsApi.getRegisterProductRequestSingleForEdit(currentItem._id);
      if (type === 'ticket')
        r = await OperatorsApi.getTicketSingleForEdit(currentItem._id);
      if (type === 'special_request')
      {
        r = await OperatorsApi.getSpecialRequestSingleForEdit(currentItem._id);
      }

      this.itemLoading = false;

      if (!r)
      {
        showSystemNoti('danger','امکان ارتباط با سرور وجود ندارد.')
        this.modal.hide();
        return;
      }
      if (!r.ok)
      {
        this.itemError = r.error;
        return;
      }
      if (r.ok)
      {
        this.current_type = type;
        this.currentItem = item.item;
      }
      this.itemLoading =false;
    },
    connectToSocket()
    {

      this.socket.on('newVerifyRequest', (data) =>
      {
        this.items.push(data);
      });
      this.socket.on('itemLocked', (id) =>
      {
        for (let i=0;i<this.items.length;i++)
        {
          if (this.items[i].item._id===id)
          {
            this.items[i].item.locked = true;
            break;
          }
        }
      });
      this.socket.on('itemUnlocked', ({id,type}) =>
      {
        if (Array.isArray(id) && this.currentItem && this.currentItem._id)
        {
          for (let i = 0; i < id.length; i++)
          {
            if (type === 'expired' && this.currentItem && this.currentItem._id.toString() === id[i].toString())
            {
              //ToDo: when modal closed, set currentItem to null so this would work fine
              if (this.modal)
                this.modal.hide();
              showSystemNoti('danger', 'زمان بررسی این مورد توسط شما به اتمام رسید.')
            }
          }
        }
        else if (this.currentItem && this.currentItem._id)
        {
          if (type === 'expired' && this.currentItem && this.currentItem._id.toString() === id)
          {
            //ToDo: when modal closed, set currentItem to null so this would work fine
            if (this.modal)
              this.modal.hide();
            this.currentItem = {};
            showSystemNoti('danger', 'زمان بررسی این مورد توسط شما به اتمام رسید.')
          }
        }

        if (Array.isArray(id))
        {
          for (let j = 0; j < id.length; j++)
          {
            for (let i = 0; i < this.items.length; i++)
            {
              if (this.items[i].item._id.toString() === id[j].toString())
              {
                this.items[i].item.locked = false;
                break;
              }
            }
          }
        }
        else
        {
          for (let i = 0; i < this.items.length; i++)
          {
            if (this.items[i].item._id.toString() === id.toString())
            {
              this.items[i].item.locked = false;
              break;
            }
          }
        }
      });
      this.socket.on('itemVerified', (id) =>
      {
        for (let i = 0; i < this.items.length; i++)
        {
          console.log(this.items[i].item._id);
          if (this.items[i].item._id.toString()===id.toString())
          {
            console.log('fooooound')
            this.items.splice(i, 1);
            break;
          }
        }
        if (this.currentItem && this.currentItem._id.toString()  === id.toString())
        {
          this.modal.hide();
          this.currentItem = {};
        }
      });
    },
    async unlockItem()
    {
      //باید خود درخواست رو هم باز کنم یک درخواست به سرور ارسال بشه
      this.socket.emit('unlockItem', {type: this.current_type, id: this.currentItem._id})
      this.currentItem = {};
      this.modal.hide();
    },
    ...mapActions('socket', {
      waitForSocket: 'waitForSocket'
    })
  },
  computed: {
    sortedItems()
    {
      let items = this.filterItemsByType();
      items.sort(this.compare)
      items = items.sort((a) =>
      {
        return a.item.locked ? (1) : -1
      });
      return items;
    },
    ...mapGetters('socket', {
      socket: 'getSocket'
    }),
  },
  components: {
    RequestSpecialAccountEdit,
    TicketView,
    RequestRegisterProductEdit, AuctionRequestEdit, MarketRequestEdit, Card, UserEdit, Loading, MasterLayout
  },
}
</script>

<style scoped>
.op-item {
  display: flex;
  justify-content: flex-start;
  grid-column-gap: 5px;
  align-items: center;
}
.items-wrapper .item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  /*margin: 5px 15px;*/
  border-radius: 8px;
  padding: 10px 20px;
  width: 100%;
  min-height: 63px;
  cursor: pointer;
  position: relative;
}
.items-wrapper .lock-icon {
  position: absolute;
  left: 5px;
  top: 5px;
  color: #dc3545;
}
.items-wrapper .icon
{
  font-size: 20px;
}
.items-wrapper .user_register
{
  background: #F5EEFF;
  box-shadow: 0 5px 6px 2px rgba(0, 0, 0, 0.25);
  color: #646AFF;
}
.items-wrapper .market_request
{
  background: #EEFCFF;
  box-shadow: 0 5px 6px 2px rgba(0, 0, 0, 0.25);
  color: #4FCCE9;
}
.items-wrapper .auction_request
{
  background: #FAEEEE;
  box-shadow: 0 5px 6px 2px rgba(0, 0, 0, 0.25);;
  color: #EF5661;
}
.items-wrapper .product_register
{
  background: #E1F3FF;
  box-shadow: 0 5px 6px 2px rgba(0, 0, 0, 0.25);
  color: #45789D;
}
.items-wrapper .ticket
{
  background: #FFE4FB;
  box-shadow: 0 5px 6px 2px rgba(0, 0, 0, 0.25);
  color: #9D459A;
}
.items-wrapper .item.locked {
  background: #e4e4e4!important;
  cursor: unset;
  color: gray!important;
}
.top-items
{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.filter-items
{
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  grid-column-gap: 10px;
}
.sort_items
{
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  grid-column-gap: 10px;
}
.filter-items .item,.sort_items .item {
  border-radius: 10px;
  padding: 2px 5px 2px 25px;
  position: relative;
  cursor: pointer;
  background: #F3F3F3;
  color: #000000b3;
}
.filter-items .item::after, .sort_items .item::after{
  content: '\f111';
  font-family: "Font Awesome 6 Pro";
  position: absolute;
  left: 5px;
  font-weight: 900;
  font-size: 11px;
  top: 50%;
  transform: translateY(-50%);
}
.sort_items .item.active::after {
  color: #EF5661;
}
.item.market_request
{
  background: #EEFCFF;
  color: #4FCCE9;
}
.item.auction_request
{
  background: #FAEEEE;
  color: #EF5661;
}
.item.user_register
{
  background: #F5EEFF;
  color: #646AFF;
}
.item.special_request {
  background: #D95F5FE3;
  color: #FDEF7E;
}
.item.product_register
{
  background: #E1F3FF;
  color: #45789D;
}
.item.ticket
{
  background: #FFE4FB;
  color: #9D459A;
}
.sort_items .item
{
  background: #F3F3F3;
  color: #000000b3;
}
.filter-items .item.active {
  box-shadow: -1px 1px 3px 2px;
  border: 1px solid;
}
</style>
